import { Input } from '@popsure/dirty-swan';
import {
  QuestionnaireFormProps,
  QuestionnaireQuestions,
} from '../../../models';
import { useEffect, useState } from 'react';
import { Header } from '../../Screen';

type Name = {
  firstName: string;
  lastName: string;
};

const isName = (value: any): value is Name =>
  Boolean(
    value &&
      typeof value.firstName === 'string' &&
      value.firstName.trim() !== '' &&
      typeof value.lastName === 'string' &&
      value.lastName.trim() !== ''
  );

export const NameForm = <Questionnaire extends QuestionnaireQuestions>({
  value,
  onSubmitValue,
  question,
  featureName,
  setValidForSubmission,
  firstNameLabel = 'First name',
  lastNameLabel = 'Last name',
}: QuestionnaireFormProps<Questionnaire, Name> & {
  firstNameLabel?: string;
  lastNameLabel?: string;
}) => {
  const [name, setName] = useState<Name>(
    value || { firstName: '', lastName: '' }
  );

  useEffect(() => {
    setValidForSubmission(isName(name));
  }, [name, setValidForSubmission]);

  const handleSubmit = () => {
    if (!name) {
      throw new Error(
        `[${featureName}] Name is missing for submission for question: ${question}`
      );
    }
    onSubmitValue(name);
  };

  return (
    <Header onSubmit={handleSubmit}>
      <>
        <Input
          placeholder={firstNameLabel}
          type="text"
          required={true}
          value={name?.firstName}
          onChange={(e) =>
            setName({
              firstName: e.target.value,
              lastName: name?.lastName ?? '',
            })
          }
          data-cy="input-name-first"
        />
        <Input
          placeholder={lastNameLabel}
          className="mt8"
          type="text"
          required={true}
          value={name?.lastName}
          onChange={(e) =>
            setName({
              firstName: name?.firstName ?? '',
              lastName: e.target.value,
            })
          }
          data-cy="input-name-last"
        />
      </>
    </Header>
  );
};
